<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-download-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.498 26a1 1 0 011 1v10.331l2.937-2.938a1 1 0 011.414 0l1.415 1.415a1 1 0 010 1.414l-7.072 7.07a1 1 0 01-1.414 0l-7.07-7.07a1 1 0 010-1.414l1.413-1.415a1 1 0 011.415 0l2.962 2.964V27a1 1 0 011-1h2zM28 6c9.62 0 17.477 7.546 17.975 17.042h-4.007C41.475 15.757 35.41 10 28 10a14.007 14.007 0 00-13.312 9.65l-.673 2.06-2.094.562A8.005 8.005 0 006 30a8 8 0 008 8h10.817l3.838 3.988A18.26 18.26 0 0128 42H14C7.373 42 2 36.627 2 30c0-5.55 3.768-10.22 8.886-11.592C13.238 11.205 20.01 6 28 6z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudDownloadAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
